/**
 * @description 文件处理相关
 * @created 2024/04/27 16:15:11
 */

/**
 * @description File 对象转 base64
 * @created 2024/04/27 16:15:18
 */
export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}

/**
 * @description File 对象转 url
 * @created 2024/04/28 09:57:47
 */
export function fileToUrl(file) {
  if (window.createObjectURL !== undefined) {
    return window.createObjectURL(file)
  } else if (window.URL !== undefined) {
    return window.URL.createObjectURL(file)
  } else if (window.webkitURL !== undefined) {
    return window.webkitURL.createObjectURL(file)
  }
  return ""
}
